// utils/s3Helper.js
export const getS3KeyFromUrl = (url) => {
  if (!url) return '';
  if (!url.startsWith('http')) return url; // already a bare key
  try {
    const parsed = new URL(url);
    return parsed.pathname.replace(/^\/+/, ''); // strip leading slash
  } catch {
    return url;
  }
};